// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
//https://www.linkedin.com/oauth/v2/authorization?scope=r_liteprofile&client_id=81cthofw4my9ql&redirect_uri=https://dtest.binarynumbers.io/auth/linkedin&response_type=code
import Vue from 'vue'
import App from './App'
import router from './router'
import BootstrapVue from "bootstrap-vue";
import FBSignInButton from 'vue-facebook-signin-button'
import VueQrcodeReader from "vue-qrcode-reader";
import store from './store';

import Loading from 'vue-loading-overlay';
// Import stylesheet
import 'vue-loading-overlay/dist/vue-loading.css';

import VueCookies from 'vue-cookies'
import VueAxios from 'vue-axios'
import VueAuthenticate from 'vue-authenticate'
import axios from 'axios';


Vue.use(VueQrcodeReader);
Vue.use(VueCookies);
Vue.router = router;

// Init plugin
Vue.use(Loading);


//specify your base and end point url to started.
import { BASEURL } from "@/config/index";
let URL_BASE = BASEURL;

const loginUrl = `${URL_BASE}/applogin`;
const fetchUserUrl = `${URL_BASE}/auth/userDetails`;


Vue.use(VueAxios, axios)
// Vue.use(VueAuthenticate, {
//   baseUrl: 'https://dtest.binarynumbers.io', // Your API domain

//   providers: {
//     facebook: {
//       clientId: '569702670297752',
//       redirectUri: 'https://dtest.binarynumbers.io/auth/facebook' // Your client app URL
//     },
//     twitter: {
//       clientId: "LlUxDjpNUDc1Nzs6r7eD3OGpw",
//       redirectUri: 'https://dtest.binarynumbers.io/auth/twitter' 
//     },
//     instagram: {
//       clientId: "515062982485644",
//       //clientSecret: "7d5fa04245544541827fcef18d6fdf5c"
//       redirectUri: 'https://dtest.binarynumbers.io/auth/instagram' 
//     },
//     linkedin: {
//       clientId: "81cthofw4my9ql",
//       redirectUri: 'https://dtest.binarynumbers.io/auth/linkedin',
//       scope:'r_basicprofile'
//     }
//   }
// })
import VueAuth from '@websanova/vue-auth'
import VueEvents from 'vue-events'
import VueLocalStorage from 'vue-localstorage'
import VueMaterial from 'vue-material'
import VuePaginate from 'vue-paginate'

Vue.use(VueLocalStorage, { name: 'mcdStore' });
Vue.use(VueMaterial)
Vue.use(VueEvents)
Vue.use(VuePaginate)
//define this before using vue-auth and comment this if your dashboard doesn't require any authentication
Vue.use(VueAuth, {
  auth: {
    request: function (req, token) {
      this.options.http._setHeaders.call(this, req, { Authorization: 'Bearer ' + token })
    },
    response: (res) => {
      if (res.status === 401) {
        location.reload();
      }
      else if (res.data && res.data.token) {
        return res.data.token
      }
    },
  },
  http: require('@websanova/vue-auth/drivers/http/axios.1.x.js'),
  router: require('@websanova/vue-auth/drivers/router/vue-router.2.x.js'),
  tokenStore: ['cookie'],
  loginData: { url: loginUrl, fetchUser: false },
  refreshData: { url: `${URL_BASE}/auth/refresh`, method: 'GET', enabled: false },
  fetchData: { url: fetchUserUrl, method: 'GET', enabled: false },
  logoutData: { url: `${URL_BASE}/admin/logout`, method: 'GET', redirect: '/login', makeRequest: true }
})
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import "./assets/css/style.css";
Vue.config.productionTip = false

Vue.use(BootstrapVue);
Vue.use(FBSignInButton)
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: {
    App
  },
  store: store,

  template: '<App/>',
  methods: {
    // authenticate: function (provider) {
    //   this.$auth.authenticate(provider).then(function (authResponse) {
    //     this_.isAuthenticated = this_.$auth.isAuthenticated();

    //     if (provider === 'facebook') {
    //       this_.$http.get('https://graph.facebook.com/v5.0/me', {
    //         params: { access_token: this_.$auth.getToken() }
    //       }).then(function (response) {
    //         this_.response = response
    //       })
    //     } else if (provider === 'twitter') {
    //       this_.response = authResponse.body.profile
    //     } else if (provider === 'instagram') {
    //       this_.response = authResponse
    //     } else if (provider === 'linkedin') {
    //       this_.response = authResponse
    //     } 
    //   }).catch(function (err) {
    //     this_.isAuthenticated = this_.$auth.isAuthenticated()
    //     this_.response = err
    //   })
    // }
  }
})



// WEBPACK FOOTER //
// ./src/main.js